export const schoolLevel = [
	{ name: '未知', val: 0 },
	{ name: '省级', val: 1 },
	{ name: '市级', val: 2 },
	{ name: '区级', val: 3 }
]
export const schoolType = [
	{ name: '城镇', val: 2 },
	{ name: '乡村', val: 1 },
	{ name: '未知', val: 0 }
]
export const scores = [
	{ name: '未知', val: 0 },
	{ name: '分数', val: 1 },
	{ name: '等级', val: 2 }
]
export const  schoolStage = [
	{ name: '小学', val: 1 },
	{ name: '初中', val: 2 },
	{ name: '高中', val: 3 }
]
